import React from "react";

// SINGLE SOURCE OF TRUTH for the Pout Aesthetics brand mark.
// To change the logo, replace /public/brand/pout-logo.png — every login,
// dashboard, customer portal, PDF header and future email uses this file.
const LOGO_SRC = "/brand/pout-logo.png";

/**
 * Full circular Pout logo. Use anywhere the business logo should appear
 * (login, portal header, marketing surfaces, PDF cover).
 */
export function Logo({ size = 96, className = "", testId = "brand-logo" }) {
    return (
        <img
            src={LOGO_SRC}
            alt="Pout Aesthetics & Beauty"
            width={size}
            height={size}
            className={`inline-block rounded-full ${className}`}
            style={{ width: size, height: size, objectFit: "contain" }}
            data-testid={testId}
            draggable={false}
        />
    );
}

/**
 * Compact horizontal lockup — small circular logo + wordmark, used in top nav.
 */
export function Wordmark({ small = false }) {
    return (
        <div className="flex items-center select-none" data-testid="brand-wordmark">
            <Logo size={small ? 44 : 56} className="shrink-0" testId="brand-wordmark-logo" />
        </div>
    );
}

export function GoldRule({ className = "" }) {
    return (
        <div className={`flex items-center justify-center gap-3 ${className}`}>
            <span className="h-px w-8 bg-gradient-to-r from-transparent to-gold/60" />
            <span className="h-1 w-1 rotate-45 bg-gold/70" />
            <span className="h-px w-8 bg-gradient-to-l from-transparent to-gold/60" />
        </div>
    );
}
